export default __webpack_public_path__ + "static/media/entrepreneurship.76f1d603.svg";